module.exports = __webpack_public_path__ + "img/back.c3e11704.svg";